import { Injectable } from '@angular/core';
import { PermissionStatus, PushNotifications } from '@capacitor/push-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

interface deviceData {
	_id?: string;
	customerGroup: string;
	token: string;
	customer: string;
	lang?: string;
	createdAt?: string;
	updatedAt?: string;
	__v?: number;
}

@Injectable({
	providedIn: 'root',
})
export class PushNotificationService {
	// public notifications: PushNotificationSchema;
	// public currentSessionNotificationToken: string;

	readonly KEY_DEVICE_DATA = 'deviceData';

	constructor(private translateService: TranslateService) {}

	async ifPermissionCanBeRequested() {
		if (Capacitor.getPlatform() === 'web') return false;

		let permStatus: PermissionStatus = await PushNotifications.checkPermissions();
		return permStatus.receive != 'denied' && permStatus.receive != 'granted';
	}

	async requestPermission() {
		return await PushNotifications.requestPermissions();
	}

	// public async init() { //todo: dynamic import
	// 	let permStatus: PermissionStatus = await PushNotifications.checkPermissions();
	// 	if (permStatus.receive === 'denied') return;
	//
	// 	if (permStatus.receive !== 'granted') permStatus = await PushNotifications.requestPermissions();
	// 	if (permStatus.receive === 'denied') return;
	//
	// 	this.setupFCM().catch(e => console.log('There has been a problem with FCM: ', e.message));
	// }
	// private async setupFCM() {
	// 	await PushNotifications.addListener('registration', async (token: Token) => {
	// 		this.currentSessionNotificationToken = token.value;
	// 		console.log('CurrentToken ' + this.currentSessionNotificationToken);
	//
	// 		if (this.deviceData?.token && this.currentSessionNotificationToken !== this.deviceData?.token) {
	// 			this.deviceData.token = token.value;
	// 			await Api.updateDevice({ token: this.deviceData.token }, this.deviceData._id);
	// 			console.log('Token updated on storage');
	// 		} else if (this.currentSessionNotificationToken === this.deviceData?.token) {
	// 			this.deviceData.customer = this.repository?.customer?._id;
	// 			console.log('Token already saved on storage, updated customer id locally');
	// 		} else {
	// 			await this.saveToken(token.value);
	// 		}
	// 	});
	// 	await PushNotifications.addListener('registrationError', (error: RegistrationError) => {
	// 		console.log(error);
	// 	});
	// 	// foreground mode
	// 	await PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
	// 		if (notification?.data?.url) {
	// 			this.navigateToUrlFromPushNotification(notification);
	// 		}
	// 	});
	// 	// background mode and killed app mode
	// 	await PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
	// 		if (notification.notification?.data?.url) {
	// 			this.navigateToUrlFromPushNotification(notification.notification);
	// 		}
	// 	});
	//
	// 	await PushNotifications.register();
	// }
	//
	// private async saveToken(token: string) {
	// 	const data: deviceData = {
	// 		customerGroup: environment.customerGroup,
	// 		token: token,
	// 		customer: this.repository?.customer?._id,
	// 		lang: this.translateService.getCurrentLang(),
	// 	};
	// 	const deviceResponse: deviceData = await Api.createDeviceWithToken(data).catch(err => {
	// 		console.log('deviceResponse Error: ', err);
	// 	});
	// 	this.deviceData = deviceResponse || null;
	// }
	//
	// get deviceData() {
	// 	return JSON.parse(localStorage.getItem(this.KEY_DEVICE_DATA));
	// }
	//
	// set deviceData(data: deviceData) {
	// 	localStorage.setItem(this.KEY_DEVICE_DATA, JSON.stringify(data));
	// }
	//
	// private async navigateToUrlFromPushNotification(additionalData: PushNotificationSchema) {
	// 	// this.repository.isReadyOrder.next(true);
	// 	// await this.navigationService.navigateTo(JSON.stringify(additionalData.data.url));
	// }
	//
	// public async updateUserData(id: string) {
	// 	console.log('Current Id: ' + id);
	// 	const response = await Api.updateDevice({ token: this.deviceData.token, customer: id }, this.deviceData._id);
	// 	console.log(response);
	// 	if (response) {
	// 		console.log('Updated Success: ' + JSON.stringify(response));
	// 	} else {
	// 		console.log('Updated error: ' + JSON.stringify(response));
	// 	}
	// }
}
